/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('GroupTesterSimServiceApi', ($http, ApiErrorService) => {
    return {
        getSimulators: getSimulators,
        getSimulatorModel: getSimulatorModel,
        isSimulatorLocked: isSimulatorLocked,
        getRunningSimulators: getRunningSimulators
    };
    function getSimulators(req) {
        return $http.post(`api/GroupTesterSim/Simulators`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorModel(req) {
        return $http.post(`api/GroupTesterSim/GetSimulatorModel`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function isSimulatorLocked(req) {
        return $http.post(`api/GroupTesterSim/SimulatorLocked`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getRunningSimulators() {
        return $http.get(`api/GroupTesterSim/RunningSimulators`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
